import DialogComponent from "../../../common/components/functional/dialogs/DialogComponent";
import LoadingSpinner from "../../../common/components/functional/loadingSpinner/LoadingSpinner";
import { DeliveryDetailsContent } from "./DeliveryDetailsContent";
import { WageReportDeliveryDetails } from "./wageReportsAPI";

type Props = {
  wageReport: WageReportDeliveryDetails | undefined;
  isOpen: boolean;
  onClose: () => void;
  onOpenPayslip?: (payslipId: string) => void;
};

export const WageReportDeliveryDetailsModal = ({
  wageReport,
  isOpen,
  onClose,
  onOpenPayslip,
}: Props) => {
  return (
    <DialogComponent
      open={isOpen}
      onClose={onClose}
      // TODO: don't know how to produce payslip and open the dialog to test this
      sx={{
        width: "800px",
        maxHeight: "90%",
        overflowY: "scroll",
        scrollbar: "hidden",
        scrollbarWidth: "none",
        padding: "16px 16px 0 16px",
      }}
    >
      {!wageReport ? (
        <LoadingSpinner />
      ) : (
        <DeliveryDetailsContent
          deliveryDetails={wageReport}
          onClose={onClose}
          onOpenPayslip={onOpenPayslip}
        />
      )}
    </DialogComponent>
  );
};
